export enum TrainingsSortOptions {
    Feature = 'feature ASC',
    Popularity = 'Popularity DESC',
    NewToOld = 'Latest DESC',
    OldToNew = 'Latest ASC',
    NameAToZ = 'coursename ASC',
    NameZToA = 'coursename DESC',
}
